export const CONTRACT_NAME_LABEL = 'Contract Name';
export const CONTRACT_NUMBER_LABEL = 'Contract Number';
export const ACTIVE_STATUS_LABEL = 'Status: Active / On Hold';
export const EXPIRATION_DATE_LABEL = 'Expiration Date: XX/XX/XXXX';
export const SAVE_ENTITLEMENT_BTN_LABEL = 'Save Entitlement';
export const VIEW_SUMMARY = 'View Summary';
export const RESET_BTN = 'Reset';

export const GRID_HEADING_STUDY = 'Study Family | Group | Release | Year';
export const GRID_HEADING_HISTORICAL = 'Historical Data';
export const GRID_HEADING_AUTO_ADD = 'Auto. Add';
export const GRID_HEADING_REMOVE_OLD = 'Remove Old';
export const GRID_HEADING_PRODUCT = 'Product Deliverable';
export const GRID_HEADING_SEAT_MAX = 'Seat Max.';
export const GRID_HEADING_SUBSCRIBER = 'Proprietary Data (Prop Code)';

export const SAVE_ERROR_PRODUCT_DELIVERABLE =
  'A Product Deliverable is required to save.';
export const SAVE_ERROR_ENTITLEMENT_NAME =
  'Entitlement Name is required to save.';
export const SAVE_LOCATIONS_ERROR_REQUIRED =
  'Please select one or more locations';
export const SAVE_ERROR_STUDY_REQUIRED = 'A Study is required to save.';
export const SAVE_SUCCESS_MESSAGE = 'Entitlement Saved';
export const UPDATE_SUCCESS_MESSAGE = 'Entitlement Updated';
export const SEAT_MAX_REQUIRED =
  'Please provide a seat count for your deliverable';
export const HISTORICAL_DATA = [
  { key: null, value: null },
  { key: 1, value: 1 },
  { key: 2, value: 2 },
  { key: 3, value: 3 },
  { key: 4, value: 4 },
  { key: 5, value: 5 },
  { key: 6, value: 6 },
  { key: 7, value: 7 },
  { key: 8, value: 8 },
  { key: 9, value: 9 },
  { key: 10, value: 10 },
  { key: 11, value: 11 },
  { key: 12, value: 12 },
  { key: 13, value: 13 },
  { key: 14, value: 14 },
  { key: 15, value: 15 },
  { key: 16, value: 16 },
  { key: 17, value: 17 },
  { key: 18, value: 18 },
  { key: 19, value: 19 },
  { key: 20, value: 20 },
];
export const FUTURE_DATA = [
  { key: 0, value: null },
  { key: 1, value: 1 },
  { key: 2, value: 2 },
  { key: 3, value: 3 },
  { key: 4, value: 4 },
  { key: 5, value: 5 },
];
export const CA_NAV_ERROR_MSG = 'Please save the changes before proceeding.';
export const SIMMONS_LOCAL = 'Simmons Local Market Selection';
export const MRI_TOP_MARKETS = 'MRI Top Market Selection';
export const SAVE_ERROR_MARKETS_REQUIRED =
  'Please Select Local and MRI TOP Market';
export const SAVE_ERROR_LOCAL_MARKETS_REQUIRED = 'Please Select a Local Market';
export const SAVE_ERROR_MRI_MARKETS_REQUIRED = 'Please Select a MRI Top Market';
export const SELECTED_MARKETS = 'Selected Markets';
export const AVAILABLE_MEMRI_USERS = 'Available MEMRI Users';
export const SELECTED_MEMRI_USERS = 'Selected MEMRI Users';
export const HEADER_MEMRI_USERS = 'MEMRI Users';
export const OPTION_MEMRI_USERS = 'MEMRI-USERS';

export const AVAILABLE_MARKETS = 'Available Markets';
export const SEARCH_MARKETS = 'Search Markets';
export const SEARCH_MARKETS_PLACHOLDER = 'Search Markets...';
export const SEARCH_PROPCODES = 'Search Prop Codes';
export const SEARCH_PROPCODES_PLACEHOLDER = 'Search Prop Codes...';

export const PROP_CODE = 'PROP-CODE';
export const PROP_HEADER = 'Prop Codes';
export const SELECTED_PROP_CODE = 'Selected Prop Code';
export const AVAILABLE_PROP_CODE = 'Available Prop Codes';

// Internal Account ID Administration
export const INTERNAL_ACCOUNT_ID = 2823;
export const INCORRECT_SELECTION_MESSAGE =
  'RLD cannot be selected with other items other than RLD Custom File. ';
export const RLD_SELECTION =
  'Please remove other items if you wish to select RLD and RLD Custom File.';

export const RLD_CONFIRMATION =
  'You attempting to add RLD to this subscription. Are you sure you want to add RLD?';
